export enum HTTP_METHOD {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
	PATCH = 'PATCH',
}

export enum CONTENT_TYPE {
	FORM = 'application/x-www-form-urlencoded',
	OCTET_STREAM = 'application/octet-stream',
	FORM_DATA = 'multipart/form-data',
	PDF = 'application/pdf',
	JSON = 'application/json',
	XML = 'application/xml',
	IMAGE = 'image/jpeg',
	TEXT = 'text/plain',
	IMAGE_PNG = 'image/png',
	EXCEL = 'application/vnd.ms-excel',
	ZIP = 'application/zip',
	GIF = 'image/gif',
	WEBP = 'image/webp',
	SVG = 'image/svg+xml',
	BMP = 'image/bmp',
	TIFF = 'image/tiff',
	MPEG = 'audio/mpeg',
	WAV = 'audio/wav',
	MP4 = 'video/mp4',
	HTML = 'text/html',
	JAVASCRIPT = 'application/javascript',
	CSS = 'text/css',
}

export enum FileExtension {
	zip = 'zip',
	png = 'png',
	jpg = 'jpg',
	jpeg = 'jpeg',
	gif = 'gif',
	webp = 'webp',
	svg = 'svg',
	bmp = 'bmp',
	tiff = 'tiff',
	mp3 = 'mp3',
	wav = 'wav',
	mp4 = 'mp4',
	pdf = 'pdf',
	txt = 'txt',
	html = 'html',
	json = 'json',
	js = 'js',
	xml = 'xml',
	css = 'css',
	xls = 'xls',
	xlsx = 'xlsx',
	doc = 'doc',
	docx = 'docx',
}

export const TYPE_TO_EXTENSION_MAP: Partial<Record<CONTENT_TYPE, FileExtension>> = Object.freeze({
	[CONTENT_TYPE.PDF]: FileExtension.pdf,
	[CONTENT_TYPE.ZIP]: FileExtension.zip,
	[CONTENT_TYPE.TEXT]: FileExtension.txt,
	[CONTENT_TYPE.IMAGE]: FileExtension.jpg,
	[CONTENT_TYPE.IMAGE_PNG]: FileExtension.png,
	[CONTENT_TYPE.GIF]: FileExtension.gif,
	[CONTENT_TYPE.WEBP]: FileExtension.webp,
	[CONTENT_TYPE.SVG]: FileExtension.svg,
	[CONTENT_TYPE.BMP]: FileExtension.bmp,
	[CONTENT_TYPE.TIFF]: FileExtension.tiff,
	[CONTENT_TYPE.MPEG]: FileExtension.mp3,
	[CONTENT_TYPE.MP4]: FileExtension.mp4,
	[CONTENT_TYPE.WAV]: FileExtension.wav,
	[CONTENT_TYPE.JAVASCRIPT]: FileExtension.js,
	[CONTENT_TYPE.HTML]: FileExtension.html,
	[CONTENT_TYPE.JSON]: FileExtension.json,
	[CONTENT_TYPE.CSS]: FileExtension.css,
	[CONTENT_TYPE.XML]: FileExtension.xml,
});

export const EXTENSION_TO_TYPE_MAP: Partial<Record<FileExtension, CONTENT_TYPE>> = Object.entries(
	TYPE_TO_EXTENSION_MAP
).reduce((acc, [type, extension]) => {
	return { ...acc, [extension]: type };
}, {});
